import request from '@/utils/request'

export const queryPage ='/icps/system/sign/basics/equipment/QueryPage'
export const batchUpdateOrDelete ='/icps/system/sign/basics/equipment/deletes'
export const updateSortNum =''
export const saveOrUpdate ='/icps/system/sign/basics/equipment/saveOrUpdate'
export const Download ='/icps/system/sign/basics/equipment/exportEquipment'

export function equipmentMaintainsave(data) {
  return request({
    url: '/icps/system/sign/basics/equipmentMaintain/save', 
    method: 'post',
	data
  })
}
export function equipmentMaintainQueryPagee(data) {
  return request({
    url: '/icps/system/sign/basics/equipmentMaintain/QueryPage', 
    method: 'post',
	data
  })
}
export function equipmentVarifysave(data) {
  return request({
    url: '/icps/system/sign/basics/equipmentVarify/save', 
    method: 'post',
	data
  })
}
export function equipmentVarifyQueryPagee(data) {
  return request({
    url: '/icps/system/sign/basics/equipmentVarify/QueryPage', 
    method: 'post',
	data
  })
}

export function updateCheckCycle(data) {
  return request({
    url: '/icps/system/sign/basics/equipment/updateCheckCycle', 
    method: 'post',
	data
  })
}
export function QueryWhetherVerify(data) {
  return request({
    url: '/icps/system/sign/basics/equipmentVarify/QueryWhetherVerify', 
    method: 'post',
	data
  })
}

